export default {
  REGISTER_EXTENSION: '@WS/REGISTER_EXTENSION',
  UPDATE_EXTENSION: '@WS/UPDATE_EXTENSION',
};
